import { Injectable } from '@angular/core';
import { ReferenceData } from '../../../lib/models/reference-data.model';
import { ValidationErrors } from '../../../lib/models/validation/validation-errors';
import { MortgageClubsDto } from '../models/mortgage-clubs-dto.model';

@Injectable()
export abstract class ApplicationFormStore {
  public dataObservable: any;
  public mortgageClubs: MortgageClubsDto;
  public availableLoanTypes = new Map<string, Array<ReferenceData>>();
  public validationErrors: ValidationErrors;
  public isSubmitted = false;

  public setLoanTypes(loanTypes: any): void {
    this.processLoanTypes(loanTypes);
  }

  private processLoanTypes(data): void {
    const loanTypes = new Map<string, Array<ReferenceData>>();

    if (data && data.length > 0) {
      for (const item of data[0].Items) {
        const values = new Array<ReferenceData>();

        for (const refData of item.Items) {
          values.push(new ReferenceData(refData));
        }

        loanTypes.set(item.Name, values);
      }
    }

    this.availableLoanTypes = loanTypes;
  }
}
